module.exports = __webpack_public_path__ + "static/media/mirrorWrong.2b3977e1.png";